import { render, staticRenderFns } from "./CollegeCreate.vue?vue&type=template&id=42f84c4f&scoped=true&"
import script from "./CollegeCreate.vue?vue&type=script&lang=js&"
export * from "./CollegeCreate.vue?vue&type=script&lang=js&"
import style0 from "./CollegeCreate.vue?vue&type=style&index=0&id=42f84c4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f84c4f",
  null
  
)

export default component.exports